module.exports = __webpack_public_path__ + "static/img/ic_file_excel.55a0e6d2.png";